module.exports = __webpack_public_path__ + "static/media/flower_bottom@2x.aa07fc89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gift/flower_bottom@2x.png
// module id = 440
// module chunks = 0